export function CardBgPink50({
  width = 280,
  height = 180,
}: {
  width?: string | number;
  height?: string | number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 280 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="rounded-2xl"
    >
      <g clipPath="url(#clip0_1324_15454)">
        <rect width="280" height="180" fill="#FFF4F6" />
        <g clipPath="url(#clip1_1324_15454)">
          <rect
            x="100.193"
            y="162.34"
            width="20"
            height="20"
            rx="10"
            transform="rotate(-70 100.193 162.34)"
            fill="#F8AEBC"
          />
          <rect
            x="57.9785"
            y="43.8608"
            width="35"
            height="35"
            rx="17.5"
            transform="rotate(-70 57.9785 43.8608)"
            fill="#F8AEBC"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M75.0015 -29.6882C77.1413 -24.5968 74.7484 -18.7347 69.6569 -16.5949C64.1325 -14.2731 51.6833 -7.83584 41.235 3.09539C30.9597 13.8456 22.9591 28.5102 24.6073 48.0752C26.2738 67.8589 37.1341 83.5242 49.9475 94.745C51.7722 96.343 53.6227 97.8377 55.4728 99.2278C61.6501 91.9986 68.8738 86.3891 76.2257 83.1421C86.213 78.7312 97.1257 78.4508 105.903 82.2524C114.982 86.1846 122.042 94.879 120.997 106.66C120.041 117.435 113.533 124.843 105.282 128.815C97.434 132.593 88.0064 133.381 79.187 132.26C74.3097 131.641 68.1698 129.539 61.8071 126.467C60.0763 130.474 58.7758 134.788 58.0884 139.302C55.5195 156.172 61.4493 177.038 90.2925 194.678C95.0041 197.559 96.4877 203.714 93.6062 208.426C90.7247 213.138 84.5693 214.621 79.8578 211.74C44.9591 190.397 34.3977 162.024 38.3163 136.291C39.3999 129.175 41.59 122.346 44.582 116.051C41.9659 114.134 39.3472 112.047 36.7713 109.791C21.4223 96.35 6.91064 76.2593 4.67786 49.754C2.42664 23.0299 13.6704 2.98875 26.7771 -10.7238C39.7108 -24.2553 54.7813 -32.0376 61.9081 -35.0328C66.9996 -37.1726 72.8617 -34.7797 75.0015 -29.6882ZM73.0524 109.627C77.0629 111.372 80.0835 112.214 81.708 112.42C87.9498 113.213 93.2218 112.424 96.6057 110.795C99.5862 109.36 100.841 107.53 101.075 104.893C101.22 103.265 100.67 101.781 97.9546 100.605C94.9376 99.2984 89.8705 98.9796 84.3058 101.437C80.6307 103.06 76.7185 105.884 73.0524 109.627Z"
            fill="#FFD3DC"
            fillOpacity="0.996078"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1324_15454">
          <rect width="280" height="180" fill="white" />
        </clipPath>
        <clipPath id="clip1_1324_15454">
          <rect
            width="300"
            height="250"
            fill="white"
            transform="translate(-120 -35)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
